import { createAction } from 'redux-starter-kit';

/**
 * An action creator for replacing the overall bucket balance in the state
 */
export const putOverallBucketBalance = createAction('PUT_OVERALL_BUCKET_BALANCE');
